module.exports = __webpack_public_path__ + "static/media/sprout-qr-logo.b23e2593.png";